export const REFRACTORIES_WITH_CUSTOMIZATION_QUERY_KEY = 'refractoriesWithCustomization'

export const DEFAULT_CUSTOMIZATIONS_PAGE = 0
export const DEFAULT_CUSTOMIZATIONS_PAGE_LIMIT = 1000
